import React, { useMemo } from "react";
import { motion } from "framer-motion";

// Liste d'articles vérifiés et actuels
const allArticles = [
  {
    title: "Les vacances peuvent prolonger la vie et réduire les maladies cardiaques",
    description:
      "Une étude longitudinale souligne que les hommes prenant des vacances annuelles réduisent leur mortalité de 20 % et les décès par maladies cardiaques de 30 %.",
    image:
      "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?auto=format&fit=crop&w=800&q=80",
    url: "https://www.washingtonpost.com/wellness/2025/04/20/vacation-health-cardiac-bedroom-benefits/",
  },
  {
    title: "Voyager pourrait ralentir le vieillissement biologique",
    description:
      "Une étude suggère que le voyage, en favorisant l’activité physique et les interactions sociales, peut freiner le processus de vieillissement.",
    image:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
    url: "https://www.verywellhealth.com/travel-and-anti-aging-study-8722191",
  },
  {
    title: "Voyager vous rend plus heureux : la science l’affirme",
    description:
      "Selon une étude, voyager fréquemment augmente la satisfaction de vie d’environ 7 % comparé à ceux qui voyagent peu ou pas du tout.",
    image:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80",
    url: "https://news.wsu.edu/press-release/2021/01/04/frequent-travel-make-7-happier/",
  },
  {
    title: "Voyager stimule la créativité et la flexibilité mentale",
    description:
      "Après des vacances, les personnes génèrent des idées plus originales et améliorent leur capacité de pensée non conventionnelle.",
    image:
      "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=800&q=80",
    url: "https://en.wikipedia.org/wiki/Vacation", // section Creativity
  },
  {
    title: "Expériences plutôt que biens matériels : le vrai bonheur",
    description:
      "Les achats d’expériences comme les voyages procurent plus de bonheur durable que les biens matériels.",
    image:
      "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?auto=format&fit=crop&w=800&q=80",
    url: "https://pubmed.ncbi.nlm.nih.gov/31943957/", // l’article sur les purchases expérientiels
  },
  {
    title: "Voyager favorise la croissance personnelle et la résilience",
    description:
      "Le voyage améliore la résolution de problèmes, la confiance en soi et la capacité à s’adapter à l’inattendu.",
    image:
      "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?auto=format&fit=crop&w=800&q=80",
    url: "https://thetravelpsychologist.co.uk/benefits-of-travel/f/travel-personal-growth/",
  },
  {
    title: "Planifier un voyage rend déjà heureux à l’avance",
    description:
      "97 % des personnes affirment que planifier un voyage les rend plus heureuses, même avant de partir.",
    image:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=800&q=80",
    url: "https://www.ustravel.org/sites/default/files/media_root/document/PlanningTravel_MichelleGielan.pdf",
  },
  {
    title: "Le tourisme bien-être améliore la qualité de vie globale",
    description:
      "Le wellness tourism agit sur la santé physique, mentale, la qualité de vie et l’environnement.",
    image:
      "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=800&q=80",
    url: "https://pubmed.ncbi.nlm.nih.gov/PMC9869067/",
  },
];

const ArticlesInspirants = () => {
  const selected = useMemo(() => {
    const shuffled = [...allArticles].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 8);
  }, []);

  return (
    <section className="container mx-auto px-4 mb-12">
      <h2 className="text-3xl font-bold text-blue-700 mb-6 text-center">
        🌟 Le voyage, une source de bien-être prouvée
      </h2>
      <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
        Plongez dans des articles scientifiques et inspirants pour découvrir pourquoi voyager transforme votre vie.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {selected.map((art, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: idx * 0.12 }}
            className="rounded-2xl overflow-hidden shadow-xl bg-white hover:scale-105 transition border border-blue-100 flex flex-col"
          >
            <img
              src={art.image}
              alt={art.title}
              className="w-full h-40 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h3 className="font-bold text-blue-800 text-lg mb-2">{art.title}</h3>
              <p className="text-gray-600 text-sm flex-grow">{art.description}</p>
              <a
                href={art.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition text-sm text-center"
              >
                En savoir plus →
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ArticlesInspirants;
